import { useLocation } from 'react-router-dom';

import { Nullable } from '../types/general';
import { QueryParams } from '../types/url';

export const useUrlQueryParam = (
    name: QueryParams | string,
): Nullable<string> => {
    return new URLSearchParams(useLocation().search).get(name);
};
